module.exports = __webpack_public_path__ + "media/components/icons/SVG/share-dfb58c4c0fa2d85ceb820f0b3a6fe042.svg";